import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SPLIT_CARD_DEFAULT_OPTIONS, SPLIT_CARD_PRIORITY_DEFAULT_OPTIONS, SPLIT_CARD_STANDARD_DEFAULT_OPTIONS } from '@domains';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';

import { ResolveUrlPipe } from '../../../../resolve-url/resolve-url.pipe';
import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-split-card-section-split-landing',
  templateUrl: './split-card.component.html',
  styleUrl: './split-card.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, MatIcon, ResolveUrlPipe],
})
export class SplitCardSectionComponent extends BaseSectionComponent {
  defaults = SPLIT_CARD_DEFAULT_OPTIONS;
  standardDefaults = SPLIT_CARD_STANDARD_DEFAULT_OPTIONS;
  priorityDefaults = SPLIT_CARD_PRIORITY_DEFAULT_OPTIONS;

  get cardOrder(): string[] {
    return this.options?.cardOrder || this.defaults.cardOrder;
  }

  get standardBullets(): string[] {
    const bullets = this.options?.standardCardBullets;
    if (Array.isArray(bullets)) {
      return bullets.filter((b: string) => b.trim());
    }
    return this.standardDefaults.bullets;
  }

  get priorityBullets(): string[] {
    const bullets = this.options?.priorityCardBullets;
    if (Array.isArray(bullets)) {
      return bullets.filter((b: string) => b.trim());
    }
    return this.priorityDefaults.bullets;
  }

  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }

  goToStandard(): void {
    const url = this.options?.standardCardButtonUrl;
    if (url) {
      window.location.href = url;
    }
  }
}
